module.exports = __webpack_public_path__ + "static/img/company_history_shulin1985.52638257.jpg";